export default __webpack_public_path__ + "static/media/sword.f91ba8b2.webp";